import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { toolboxComponentsMap } from "../../blocks/toolboxComponentsMap";

export const ReviewsPageBody = (
    props: Immutable<Pick<templates.ReviewsPageDocumentTemplate, "page">>,
): React.JSX.Element | null => {
    if (!props.page.body) {
        return null;
    }
    return (
        <StreamField
            tagName={React.Fragment}
            value={props.page.body.value}
            components={toolboxComponentsMap}
        />
    );
};
